import React from 'react'
import '../styles/main.css'
import { Link } from 'react-router-dom'
export default function Footer() {
    return (
        <div className='footer'>
          <hr />
          <div className="container6">
            <p>
              Crafted by Rishabh Singh
            </p>
            <ul>
              <li><Link to="https://github.com/heapnotizer"><img src='/img/icons8-github-64.png' alt="github" height={24} /></Link></li>
              <li><Link to='https://www.linkedin.com/in/rishabh-singh-93b68223a'><img src='/img/icons8-linkedin-2-96.png' alt="linkedin" height={25.4} /></Link></li>
            </ul>
          </div>
        </div>

    )
}
